module.exports = __webpack_public_path__ + "../front/img/368højtrådkurv+bøjestang+hylder.730e76e7.svg";